import RemoteSelect from "common/components/RemoteSelect/RemoteSelect";
import ImageFromStrapiMedia from "common/components/ImageFromStrapiMedia/ImageFromStrapiMedia";
import type { Product } from "types";
import { ProductNameLabel } from "pages/Products/productUtils";

const processOptions = (options: Product[]) =>
  options.map(({ id, name, image, titleColor, tagColor }) => ({
    value: id,
    label: name,
    image,
    titleColor,
    tagColor,
  }));

function ProductOptionLabel({
  image,
  label,
  titleColor,
  tagColor,
}: {
  image?: Product["image"];
  label: string;
  titleColor?: string | null;
  tagColor?: string | null;
}) {
  return (
    <div className="flex items-center gap-2">
      {image?.url ? (
        <img
          src={ImageFromStrapiMedia(image).uri}
          alt={label}
          className="w-6 h-6 rounded object-cover shrink-0"
        />
      ) : (
        <div className="w-6 h-6 rounded bg-slate-200 shrink-0" />
      )}
      <ProductNameLabel
        product={{ name: label, titleColor, tagColor }}
        showColor={false}
      />
    </div>
  );
}

function ProductSelect(props: any) {
  return (
    <RemoteSelect
      url="products"
      processOptions={processOptions}
      formatOptionLabel={(option: any) => (
        <ProductOptionLabel
          image={option.image}
          label={option.label}
          titleColor={option.titleColor}
          tagColor={option.tagColor}
        />
      )}
      {...props}
    />
  );
}

export default ProductSelect;
